
import { createStyles } from "../../lib/helpers"


const styles = createStyles({
  banner: {

    width: "100vw",
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    fontSize: "calc(10px + 2vmin)",
    paddingTop: "20px",
    paddingBottom: "20px",
    borderBottom: "1px solid var(--git-black-half)",
    //  boxShadow: "0px 2px 10px var(--git-black-half)",
    backdropFilter: "blur(8px)",
    minHeight: "40vh",
    backgroundColor: "rgba(0,0,0,0.15)",
    overflowX: "hidden"


  },

})

export default styles